//-------------------- This file contains basic settings that the website requires to be loaded on every page -------------------

// --------------------- Font-awesome ------------------------ 
// Ref: https://stackoverflow.com/questions/38808306/react-create-app-using-font-awesome
// Alternative (also works) : https://www.npmjs.com/package/font-awesome-webpack
import 'font-awesome/css/font-awesome.css';


// WEBPACK FOOTER //
// ./src/redux/config/index.js